<div style='text-align:center; padding: 20px;'>
  <h1>{{data.heading}}</h1>
  <p>{{data.content}}</p>
  <p>{{data.content1}}</p>
  <div class="flex-gap">
    <button *ngIf="data.button1Text" (click)="onYes()" style='height:30px; font-size:12px; width: 90px; border-radius:5px; border-color:#6788a3; background-color: #00569d; color:white; cursor:pointer'>{{data.button1Text}}</button>
    <button *ngIf="data.button2Text" (click)="onNo()" style='height:30px; font-size:12px; width: 90px; border-radius:5px; border-color:#d87772; background-color:#db2016; color:white;cursor:pointer'>{{data.button2Text}}</button>
  </div>
  <p></p>

</div>